import styled from "styled-components";

export const LabelText = styled.label`
  font-weight: bold;
  line-height: 20px;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;
